/**
 * js App
 *
 * @see bootstrap.js http://v4-alpha.getbootstrap.com/getting-started/javascript/
 * @see swiper.js    http://idangero.us/swiper/api/
 */
var App = function($){

  /**
   * Set listeners
   */
  var set_listeners = function(){
    countdown();
  };
  
  /**
   * Event countdown
   */
  var countdown = function() {
    function getTimeRemaining(endtime) {
      var t = Date.parse(endtime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
      var days = Math.floor(t / (1000 * 60 * 60 * 24));
      return {
        'total': t,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
      };
    }
    
    function initializeClock(id, endtime) {
      var clock = document.getElementById(id);
      var daysSpan = clock.querySelector('.days');
      var hoursSpan = clock.querySelector('.hours');
      var minutesSpan = clock.querySelector('.minutes');
      var secondsSpan = clock.querySelector('.seconds');
    
      function updateClock() {
        var t = getTimeRemaining(endtime);
    
        daysSpan.innerHTML = t.days;
        hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
        minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
        secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
    
        if (t.total <= 0) {
          clearInterval(timeinterval);
        }
      }
    
      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
    }
    
    if($('#js-clock').length){
      var deadline = new Date(new Date($('#js-clock').data('date')));
      initializeClock('js-clock', deadline);
    }
  }
  
	return {
		init: function(){
      set_listeners();
    }
  }
}(jQuery);

(function(){
	App.init();
})();